import { render } from "./UpdateFDDetails.vue?vue&type=template&id=2e538031"
import script from "./UpdateFDDetails.vue?vue&type=script&lang=js"
export * from "./UpdateFDDetails.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__